import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=4f8c544a&scoped=true"
import script from "./DefaultModal.vue?vue&type=script&lang=ts"
export * from "./DefaultModal.vue?vue&type=script&lang=ts"
import style0 from "./DefaultModal.vue?vue&type=style&index=0&id=4f8c544a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c544a",
  null
  
)

export default component.exports